import {RepeatsTable} from "../types/repeats-modal.types";

export const repeatsModalName = 'repeats';

export const repeatsTable: Array<RepeatsTable> = [
  {
    key: 'record-lists-repeats',
    title: 'Предложения о сотрудничестве',
  },
  {
    key: 'record-calendars-repeats',
    title: 'Рекламные Кампании',
  }
]
